import { UrlList } from 'app/main/pages/authentication/shared/url-list.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class RoomsService {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
        this.urlRooms = UrlList.URL_ROOMS;
        this.urlConversationRoomsIntegra = UrlList.URL_CONVERSATIONS_ROOMS_INTEGRA;
    }
    getRoomsByCustomer(data) {
        return this._httpClient.post(`${this.urlConversationRoomsIntegra}/findRooms?page=0&size=200`, data);
    }
}
RoomsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RoomsService_Factory() { return new RoomsService(i0.ɵɵinject(i1.HttpClient)); }, token: RoomsService, providedIn: "root" });
